import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 48px;
  transform: scale(0.8);
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 10px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  height: 48px;
  justify-content: center;
  margin-right: 10px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  color: #000000;
  font-size: 44px;
  font-style: normal;
  font-weight: normal;
  line-height: 48px;
  padding: 0 8px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #FFFFFF;
  display: flex;
  font-weight: bold;
  justify-content: center;
  margin: 0 4px;
  min-width: 48px;
`;
PointsContainer.displayName = 'PointsContainer';

export const TeamContainer = styled.div`
  background-color: #2B38C2;
  display: flex;
  height: 48px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  color: #ffffff;
  display: flex;
  font-size: 40px;
  font-style: normal;
  font-weight: normal;
  justify-content: center;
  letter-spacing: 0px;
  line-height: 48px;
  padding: 0 32px;
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #142441;
  display: flex;
  height: 48px;
  justify-content: center;
  margin-left: 8px;
  min-width: 146px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #FFFFFF;
  font-size: 44px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 48px;
  text-align: center;
`;
Timer.displayName = 'Timer';
